import { render, staticRenderFns } from "./activeAgreementsChartBox.vue?vue&type=template&id=68511764&"
import script from "./activeAgreementsChartBox.vue?vue&type=script&lang=js&"
export * from "./activeAgreementsChartBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports